module.exports = __webpack_public_path__ + "img/icons/favicon-32x32.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/static/images/icons/favicon-32x32.png
 ** module id = 162
 ** module chunks = 0
 **/